var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_GoalSettings_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_GoalSettings_Delete_Body"
          ),
          brickTitle: _vm.title
        },
        brick: _vm.brick,
        name: _vm.newName,
        invalid: _vm.$v.$invalid || _vm.isLoading || !_vm.customConditionsValid
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.onSave()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        },
        "display-errors": function($event) {
          return _vm.displayErrorMessages()
        }
      }
    },
    [
      _c("settings-item", {
        attrs: {
          icon: "fas fa-plane-arrival",
          label: _vm.resource("JourneyBuilder_GoalSettings_GoalType_Label")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      options: _vm.selectableGoalTypes,
                      disabled:
                        !_vm.canWrite || _vm.selectableGoalTypes.length === 0,
                      clearable: false,
                      searchable: "",
                      filterable: "",
                      taggable: "",
                      "close-on-select": ""
                    },
                    model: {
                      value: _vm.goalTypeModel,
                      callback: function($$v) {
                        _vm.goalTypeModel = $$v
                      },
                      expression: "goalTypeModel"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          },
          {
            key: "errors",
            fn: function() {
              return [
                _vm.$v.goalTypeModel.$dirty && _vm.$v.goalTypeModel.$invalid
                  ? _c("required-error-message", {
                      attrs: {
                        "field-name": _vm.resource(
                          "JourneyBuilder_GoalSettings_GoalType_Label"
                        )
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          label: _vm.resource("JourneyBuilder_GoalSettings_DeleteRecords_Label")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("toggle-button", {
                  attrs: {
                    sync: true,
                    labels: {
                      checked: _vm.resource("Bool_Yes"),
                      unchecked: _vm.resource("Bool_No")
                    },
                    width: 78
                  },
                  model: {
                    value: _vm.settings.deleteRecords,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "deleteRecords", $$v)
                    },
                    expression: "settings.deleteRecords"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("goal-custom-conditions", {
        ref: "customConditions",
        attrs: { "goal-type": _vm.goalTypeModel && _vm.goalTypeModel.id },
        on: {
          "loading-state-changed": function($event) {
            _vm.isLoading = $event
          },
          "validation-state-changed": function($event) {
            _vm.customConditionsValid = $event
          }
        },
        model: {
          value: _vm.settings.customConditions,
          callback: function($$v) {
            _vm.$set(_vm.settings, "customConditions", $$v)
          },
          expression: "settings.customConditions"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }